module.exports = __webpack_public_path__ + "img/file-plus.2754ac45.svg";